import { AppProviders } from '@/providers/AppProviders';
import { AppRouter } from '@/routes/AppRouter';
import { ToastContainer } from '@/components/feedback/ToastContainer';
import { ScrollToTop } from '@/components/common/ScrollToTop';

export function App() {
  return (
    <AppProviders>
      <ScrollToTop />
      <AppRouter />
      <ToastContainer />
    </AppProviders>
  );
}
